import { useEffect } from "react";

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical,
  image = "/logo.png"
}) => {
  const siteName = "Glamour Body";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Advanced Skincare & Body Contouring in Katy, Texas`;
  
  useEffect(() => {
    // Set document title
    document.title = fullTitle;
    
    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    
    // Standard meta tags
    if (description) updateMetaTag('description', description);
    if (keywords) updateMetaTag('keywords', keywords);
    
    // Open Graph
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:title', fullTitle, true);
    if (description) updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', image, true);
    updateMetaTag('og:site_name', siteName, true);
    
    // Twitter
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', fullTitle);
    if (description) updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);
    
    // Canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }
  }, [fullTitle, description, keywords, canonical, image]);
  
  return null;
};

export default SEO;
